var espresso = espresso || {},
    hsp = hsp || {};
( function () {
    'use strict';
    jQuery( function () {
        hsp.init();
    } );
    hsp.init = function () {};
    espresso.maps.helpers.icon = function ( type ) {
        var icons = {
            standard: {
                url: '/Files/Templates/Designs/ftz-master/assets/img/brand-specifics/hella-marker-icon.png',
                anchor: new google.maps.Point( 11, 11 ),
                scaledSize: new google.maps.Size( 25, 25 ),
                permissions: false,
                name: ''
            },
            webshopBooking: {
                url: '/Files/Templates/Designs/ftz-master/assets/img/rasterized-graphics/brand-specifics/hella-marker-icon.png',
                anchor: new google.maps.Point( 11, 11 ),
                scaledSize: new google.maps.Size( 25, 25 ),
                permissions: true,
                name: 'Webshop / Book tid online'
            },
            webshop: {
                url: '/Files/Templates/Designs/ftz-master/assets/img/rasterized-graphics/brand-specifics/hella-marker-icon.png',
                anchor: new google.maps.Point( 11, 11 ),
                scaledSize: new google.maps.Size( 25, 25 ),
                permissions: true,
                name: 'Webshop'
            },
            booking: {
                url: '/Files/Templates/Designs/ftz-master/assets/img/rasterized-graphics/brand-specifics/hella-marker-icon.png',
                anchor: new google.maps.Point( 11, 11 ),
                scaledSize: new google.maps.Size( 25, 25 ),
                permissions: true,
                name: 'Book tid online'
            },
            selected: {
                url: '/Files/Templates/Designs/ftz-master/assets/img/rasterized-graphics/brand-specifics/hella-marker-icon.png',
                anchor: new google.maps.Point( 11, 11 ),
                scaledSize: new google.maps.Size( 25, 25 ),
                permissions: false,
                name: ''
            }
        };
        if ( type === undefined ) {
            return icons;
        }
        else {
            return icons[ type ];
        }
    };
}() );


var ftz = ftz || {};
( function () {
    'use strict';
    jQuery( function () {
        ftz.checkout.approve();
    } );
    ftz.checkout = {
        approve: function () {
            var jCheckboxes = jQuery( '.js-ftzam-EcomOrderCustomerAccepted' );
            jCheckboxes.on( 'change', function ( event ) {
                jCheckboxes.not( event.target ).prop( 'checked', jQuery( event.target ).prop( 'checked' ) === true );
            } );
        }
    };
}() );
/* Google Maps api key */ 
//master.settings.maps.apiKey = 'AIzaSyCYES2nkG9or1ketR376UtGGXOXF6jwJYY';


$(document).ready(function () {
	(function () {
		var input = $('#ServiceCatalog_NewProduct_ShortDescription');
		input.on('keyup', function (e) {
			$('#characters').text(160 - e.target.value.length);
		});
	}());

	// when user clicks on accept terms the checkboxes auto checks
	(function () {
		var acceptedTop = $('#EcomOrderCustomerAcceptedTop');
		var acceptedBottom = $('#EcomOrderCustomerAccepted');

		if (acceptedTop.length && acceptedBottom.length) {
			var acceptTermsBtn = $('#accept-terms-btn');
			acceptTermsBtn.click(function () {
				acceptedBottom.prop("checked", true);
				acceptedTop.prop("checked", true);
			});
		}
	})();

});